export default __webpack_public_path__ + "static/media/P800_RoHS.82abfcd3.pdf";